"use client";

import { SectionBadge } from "./SectionBadge";
import { useI18n } from "@/i18n/context";

export function TransparencySection() {
  const { t } = useI18n();

  return (
    <section id="transparency" className="relative bg-bg-warm py-[101px] px-8">
      {/* Entire block fades in with no movement — stillness creates contrast */}
      <div data-reveal="fade">
        <div className="mb-[80px]">
          <SectionBadge>{t.transparency.badge}</SectionBadge>
        </div>

        <h2 className="font-clash font-bold text-[38px] text-text-primary text-center uppercase tracking-[2.66px] leading-normal max-w-[1320px] mx-auto mb-[48px] whitespace-pre-line">
          {t.transparency.title}
        </h2>

        <div className="font-besley text-[24px] text-text-secondary text-center tracking-[1.68px] leading-normal max-w-[776px] mx-auto space-y-[28px]">
          {t.transparency.lines.map((line, i) => (
            <p key={i} className="whitespace-pre-line">
              {line}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
